import { INTERFACE } from '@/utils/INTERFACE';
import { getCurrency } from '@/utils/currency';
import http from '@/utils/http';
import { getSystem } from '@/utils/site';
import Cookies from 'js-cookie';
import _ from 'lodash';
import { getChannelNumber, getSiteNumber } from '@/utils/siteDefs';
import {SplitQueue} from '@/utils/queue'
import {withCache} from '@/utils/cache'

async function _getPrice(skus) {
	var sys=getSystem()
	var pool={}
	if(sys=='ept'){
		var queue=new SplitQueue(async chunk => http.jsonp.get(INTERFACE().skuPrice, {
				json: JSON.stringify({
					channel:getChannelNumber(),
					curList:[getCurrency()],
					site:getSiteNumber(),
					skuIds:chunk
				})
		}),20)
		let data=await queue.fetch(skus)
		for (let i in data) {
			let item=data[i].plummetInfoDto.priceInfos[0]
			pool[data[i].skuId] = {
				discountPrice: item.discountPrice,
				jdPrice: item.jdPrice,
				discount:item.discountOff,
			}
		}
	}
	if(sys=='th'){
		let chunks = _.chunk(skus, 10)
		let requests = []
		for (let i = 0; i < chunks.length; i++) {
			let getChunk = (chunk) => http.jsonp.get("//p.jd.co.th/prices/mgets", {
				skuIds: chunk.join(","),
				language: Cookies.get('language'),
			})
			requests.push(getChunk(chunks[i]))
		}
		let data = await Promise.all(requests)
		_.flatten(data).forEach(it => {
			pool[it.id] = {
				discountPrice: it.p,
				jdPrice: it.op,
				discount:it.p>-1?Math.round((it.op-it.p)/it.op*100):0
			}
		})
	}
	return pool
}

export const getPrice=withCache(_getPrice)

/**
 * 
 * @param [Number] spus 
 * @returns {
 * 		{Number}:{
 * 			hprice: Number, 
 * 			lprice: Number
 * 		}
 * }
 */
async function _getSpuPrice(spus) {
	var pool={}
	var cur=getCurrency()
	var res = await http.jsonp.get(INTERFACE().spuPrice, {
		json: JSON.stringify({
			channel:getChannelNumber(),
			curList:[cur],
			site:getSiteNumber(),
			spuIds:spus
		})
	})
	for(let i=0;i<res.length;i++){
		pool[res[i].spuId]=res[i].prices[0]
	}
	return pool
}

export const getSpuPrice=withCache(_getSpuPrice)